<template>
  <!-- 
    实物核销弹框：
    1. 如果没有实物奖品，则没有核销功能
   -->
  <el-dialog
    title="实物奖品核销"
    :visible.sync="visible"
    width="650px"
    :before-close="toggle"
    destroy-on-close
    class="write-off-dialog"
    v-loading="loading"
  >
    <template v-if="itemData">
      <el-descriptions :column="1" size="small" colon labelClassName="text-base text-default-color" contentClassName="text-base text-default-color">
        <el-descriptions-item label="用户名称">{{ itemData.userName || '' }}</el-descriptions-item>
        <el-descriptions-item label="农户姓名" v-if="itemData.personName">{{ itemData.personName }}</el-descriptions-item>
      </el-descriptions>
  
      <TaskProgressItem :isWriteOff="item.prizeType===20" :checkable="false" v-model="item.pickNumber" :item-data="item" v-for="(item, index) in itemData.prizes" :key="index" />
    </template>

    <el-empty v-else description="暂无内容" />
  
    <div slot="footer" class="flex justify-center">
      <el-button :type="canWriteOff ? 'primary' : ''" @click="handleConfirm">{{ canWriteOff ? '确认核销' : '关闭' }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TaskProgressItem from './TaskProgressItem.vue'
import { getActivityPrizeUserTaskHistoryApi, postExchangeForActivityPrizeApi } from '@/api'
export default {
  name: "WriteOffDialog",
  components: { TaskProgressItem },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    recordId: {
      type: String
    },
    zxmUserId: {
      type: String
    },
  },
  data() {
    return {
      visible: false,
      loading: false,

      itemData: null,
    }
  },
  computed: {
    /** 是否可核销（必须有实物奖品） */
    canWriteOff() {
      if (!this.itemData) {
        return false
      }

      // 有库存的实物奖品列表
      let solidPrizes = this.itemData.prizes.filter(item => item.prizeType === 20).filter(item => (item.surplusNum > 0 || item.prizeLimitType === 10 || item.num === -1))
      solidPrizes = solidPrizes.filter(item => {
        let _picked = item.picks.map(i => i.writeOffNum).reduce((k, j) => k+j, 0)
        if (item.prizeLimitType === 10) {
          return true
        } else {
          return _picked < item.prizeLimitNum
        }
      })
      return solidPrizes.length > 0
    },
  },
  watch: {
    show: {
      immediate: true,
      async handler(newVal) {
        this.visible = newVal
        if (newVal) {
          await this.loadData()
        } else {
          setTimeout(() => {
            this.itemData = null
          }, 301);
        }
      },
    }
  },
  methods: {
    toggle() {
      this.visible = !this.visible
      this.$emit('update:show', this.visible)
    },

    handleConfirm() {
      if (!this.canWriteOff) { // 无实物奖品时直接关闭
        this.toggle()
        return
      }

      // 任务未完成时提示
      let isTasksFinished = this.checkTaskFinished()
      if (!isTasksFinished) {
        return
      }

      let list = this.itemData.prizes.filter(item => item.prizeType===20) // 过滤掉非实物奖品
      let displayContent = list.map(item => {
        let pickedNum = item.picks.map(i => i.writeOffNum).reduce((i, j) => i+j, 0)
        let surplusNum = item.num === -1 ? Number.MAX_SAFE_INTEGER : item.surplusNum > 0 ? item.surplusNum : 0
        let extend = ''
        if (item.prizeLimitType !== 10) { // 家庭/个人限量
          if (!surplusNum) {
            extend = `剩余份数为 0，本次无法发放。`
          } else if(surplusNum < item.pickNumber) {
            extend = `剩余份数 ${surplusNum} 份，本次只能发放 ${surplusNum} 份。`
          }
        }
        let limitText = item.prizeLimitType === 10 ? '不限制份数' : `每${item.prizeLimitType===20 ? '人' : '户'}限制领取 ${item.prizeLimitNum} 份`
        return `<div>${item.prizeName}，${limitText}，${item.prizeLimitType===30 ? '家庭成员' : ''}已领 ${pickedNum} 份，本次应发放 ${item.pickNumber} 份。${extend}</div>`
      }).join('')

      this.$confirm(`<div>${displayContent}</div>`, '确认核销', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          customClass: 'remove-icon-message-box',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              let result = await this.postWriteOff()
              if (!result) {
                return
              }
            }
            done()
          }
        }).catch(_err => {
        })
    },

    /** 核销时检查要核销的商品是否已完成对应任务 */
    checkTaskFinished() {
      let data = [...this.itemData.prizes]
      data = data.filter(item => item.pickNumber)
      for(let i = 0; i < data.length; i++) {
        let unfinished = data[i].tasks?.filter(item => !item.state) || []
        if (unfinished.length) {
          let unfinishedText = unfinished.map(item => `“${item.taskName}”`).join('、')
          this.$message.warning(`${data[i].prizeName} 下任务${unfinishedText}未完成！`)
          return false
        }
      }

      return true
    },

    /** 发起核销请求 */
    async postWriteOff() {
      try {
        let data =this.itemData.prizes.map(item => ({
          activityPrizeId: item.prizeId,
          pickNumber: item.pickNumber,
          zxmUserId: this.zxmUserId
        }))
        let res = await postExchangeForActivityPrizeApi(data)
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '核销成功!'
          });
          this.$emit('refresh')
          this.toggle()
          return true
        }
        return false
      } catch(err) {
        console.log(err)
        return false
      }
    },

    async loadData() {
      try {
        this.loading = true
        let res = await getActivityPrizeUserTaskHistoryApi(this.recordId)
        this.loading = false
        if (res.code === 0) {
          // 只显示实物
          res.data.prizes = res.data?.prizes.filter(item => item.prizeType === 20) || []
          // item.pickNumber：本次发放数，双向绑定的值
          res.data.prizes.forEach(item => item.pickNumber=0)
          this.itemData = res.data
        }
      } catch(err) {
        this.loading = false
        console.log(err)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.write-off-dialog {
  /deep/ .el-dialog__body {
    max-height: 55vh;
    overflow-y: auto;
  }
}
</style>

<style lang="less">

</style>